export default __webpack_public_path__ + "static/aroundH4cSplash-4ff9cba8a64ec5eb9bb0fafaeaae1383.svg";